export const Pricing = {
  All: 'all',
  Free: 'free',
  Paid: 'paid'
};